var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserMetrics(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    id: "_x32_",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#000000;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M510.159,392.023l-45.586-57.326V93.61c0-11.662-9.458-21.121-21.121-21.121H68.539 c-11.662,0-21.111,9.458-21.111,21.121v241.087L1.834,392.023C0.64,393.518,0,395.368,0,397.288v25.373 c0,9.311,7.539,16.849,16.841,16.849h478.31c9.302,0,16.849-7.538,16.849-16.849v-25.373 C512,395.368,511.351,393.518,510.159,392.023z M77.219,102.29h357.554v202.607H77.219V102.29z M304.119,419.472h-96.238v-25.478 h96.238V419.472z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 132.064,
    y: 245.315,
    className: "st0",
    width: 35.41,
    height: 35.41
  }), /*#__PURE__*/React.createElement("rect", {
    x: 185.179,
    y: 209.904,
    className: "st0",
    width: 35.41,
    height: 70.821
  }), /*#__PURE__*/React.createElement("rect", {
    x: 238.295,
    y: 192.199,
    className: "st0",
    width: 35.41,
    height: 88.526
  }), /*#__PURE__*/React.createElement("rect", {
    x: 291.41,
    y: 139.084,
    className: "st0",
    width: 35.41,
    height: 141.642
  }), /*#__PURE__*/React.createElement("rect", {
    x: 344.526,
    y: 174.494,
    className: "st0",
    width: 35.41,
    height: 106.231
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserMetrics);
export default __webpack_public_path__ + "static/media/user_metrics.801bc2c7bdc2fa5bcbbfc4b8c9856820.svg";
export { ForwardRef as ReactComponent };